import { useState } from 'react'
import { Avatar, CreatedLine, TripsLine, openUser } from './bits'
import { passengerName } from './users'
import { formatAmount, passengerBreakdown } from './money'

function MoneyLine({ breakdown }) {
  const parts = []
  if (breakdown.seats != null) {
    parts.push(`${breakdown.seats} ${breakdown.seats === 1 ? 'asiento' : 'asientos'}`)
  }
  if (breakdown.total != null) {
    parts.push(`$${formatAmount(breakdown.total)}${breakdown.estimated ? '*' : ''}`)
  }
  if (breakdown.wallet > 0) parts.push(`saldo $${formatAmount(breakdown.wallet)}`)
  if (breakdown.coupon) parts.push(`cupón ${breakdown.coupon}`)
  if (!parts.length) return null
  return (
    <span className='block text-xs font-medium text-ink dark:text-gray-200 truncate'>
      {parts.join(' · ')}
    </span>
  )
}

function Breakdown({ breakdown, card, email }) {
  return (
    <div className='mt-1 ml-[46px] mb-1.5 flex flex-col gap-0.5 text-xs text-warm_gray dark:text-gray-400'>
      <span className='tabular-nums'>Al conductor ${formatAmount(breakdown.toDriver)}</span>
      <span className='tabular-nums'>Fee ${formatAmount(breakdown.fee)}</span>
      {breakdown.discount > 0 && (
        <span className='tabular-nums'>Descuento −${formatAmount(breakdown.discount)}</span>
      )}
      {breakdown.estimated && breakdown.total != null && (
        <span>* total estimado, sin dato del cobro</span>
      )}
      {breakdown.wallet > 0 && (
        <span className='tabular-nums'>Pagó con saldo Viatik ${formatAmount(breakdown.wallet)}</span>
      )}
      {card && (
        <span className='tabular-nums'>
          Tarjeta {card.first_six_digits}…{card.last_four_digits}
        </span>
      )}
      {email && <span className='truncate'>{email}</span>}
    </div>
  )
}

export default function PassengerRow({ passenger }) {
  const [open, setOpen] = useState(false)

  const name = passengerName(passenger)
  const breakdown = passengerBreakdown(passenger)
  const transaction = passenger.transaction || {}
  const card = transaction.payment && transaction.payment.card
  const email =
    transaction.preference && transaction.preference.payer && transaction.preference.payer.email
  const userId = passenger.user && passenger.user.user_id

  return (
    <div className='rounded-2xl hover:bg-coral/[0.06] transition-colors'>
      <div className='flex items-center gap-1'>
        <button
          onClick={() => setOpen(o => !o)}
          className='flex flex-1 items-center gap-3 rounded-2xl px-2 py-1.5 text-left min-w-0 focus:outline-none focus-visible:ring-2 focus-visible:ring-coral/40'
        >
          <Avatar src={passenger.user && passenger.user.picture} name={name} size={34} />
          <span className='min-w-0 flex-1'>
            <span className='block text-sm font-medium truncate'>{name}</span>
            <MoneyLine breakdown={breakdown} />
            <CreatedLine user={passenger.user} />
            <TripsLine user={passenger.user} />
          </span>
          <span className='text-warm_gray dark:text-gray-400 shrink-0 pr-1' aria-hidden='true'>
            {open ? '▴' : '▾'}
          </span>
        </button>
        {userId && (
          <button
            onClick={() => openUser(userId)}
            title='Ver usuario'
            aria-label={`Ver usuario ${name}`}
            className='shrink-0 rounded-xl px-2 py-1.5 text-warm_gray dark:text-gray-400 hover:text-coral_deep hover:bg-coral/10 transition-colors focus:outline-none focus-visible:ring-2 focus-visible:ring-coral/40'
          >
            ↗
          </button>
        )}
      </div>
      {open && <Breakdown breakdown={breakdown} card={card} email={email} />}
    </div>
  )
}
